import { createFileRoute } from '@tanstack/react-router'
import { TicketsList } from '@/features/tickets/components/tickets-list'

export const Route = createFileRoute('/_authenticated/tickets/')({
  component: TicketsList,
})
